import Vue from 'vue';
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        count: 0,
        // imgHost: 'http://192.168.2.135:8787',
        // imgHost: 'http://bszm.test.zkpsych.com',
        imgHost: 'https://zsgl.psych.ac.cn',
    },
    mutations: {
        increment (state) {
            state.count++
        }
    }
});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.js